/**
 * Keeps the price shown on the custom "add to cart" button in sync with
 * the selected variant. Dawn's product-info.js already publishes
 * PUB_SUB_EVENTS.variantChange with the freshly fetched variant whenever
 * the shopper changes an option, so we just listen for that.
 */
(function () {
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var format = window.hlMoneyFormat || '{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var precision = match && match[1] === 'amount_no_decimals' ? 0 : 2;
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    value = parts.join('.');
    return format.replace(placeholderRegex, value);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event.data.sectionId;
      var variant = event.data.variant;

      document.querySelectorAll('[data-hl-cart-price][data-hl-section-id="' + sectionId + '"]').forEach(
        function (el) {
          if (!variant) return;
          el.textContent = formatMoney(variant.price);
        }
      );

      var button = document.querySelector('.hl-btn-cart-price[data-hl-section-id="' + sectionId + '"]');
      if (button) {
        button.disabled = !variant || variant.available === false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
